import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/httpAgency'

export const pressRoomKeyRequestList = (params = '') => Http.get(`/press-room-key-requests${serialize(params)}`)
export const pressRoomKeyRequestByID = (id) => Http.get(`/press-room-key-requests/${id}`)
export const pressRoomKeyRequestApprove = (id) => Http.post(`/press-room-key-requests/${id}/approve`)
export const pressRoomKeyRequestReject = (id) => Http.post(`/press-room-key-requests/${id}/reject`)
